import { useState } from 'react';
import AppLayout from '@/components/feature/AppLayout';
import { legalKnowledge } from '@/mocks/systemData';

export default function SWLegalPage() {
  const [legalCaseType, setLegalCaseType] = useState('Physical Abuse');

  const filtered = legalKnowledge.filter((l) => l.caseTypes.includes(legalCaseType));

  return (
    <AppLayout title="Legal Reference" breadcrumb={['Social Worker', 'Legal Ref.']}>
      <div className="space-y-4">
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3">
          <i className="ri-scales-3-line text-amber-600 mt-0.5 text-lg" />
          <div>
            <p className="text-sm font-semibold text-amber-800">Legal Reference for Social Workers</p>
            <p className="text-xs text-amber-600">View applicable laws and guidelines per case type. Use these in your reports and documentation.</p>
          </div>
        </div>
        <div className="bg-white rounded-xl border border-gray-100 p-5">
          <label className="text-sm font-medium text-gray-700 mb-2 block">Filter by Case Type</label>
          <select value={legalCaseType} onChange={(e) => setLegalCaseType(e.target.value)} className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-teal-500 cursor-pointer">
            {['Physical Abuse', 'Sexual Abuse', 'Emotional Abuse', 'Neglect', 'Child Labor', 'Child Trafficking', 'Domestic Violence', 'Online Sexual Exploitation'].map((ct) => <option key={ct}>{ct}</option>)}
          </select>
        </div>

        <div className="space-y-3">
          {filtered.map((doc) => (
            <div key={doc.id} className="bg-white rounded-xl border border-gray-100 p-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-amber-50 rounded-xl flex items-center justify-center flex-shrink-0"><i className="ri-scales-3-line text-amber-600 text-lg" /></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs font-mono bg-gray-100 text-gray-600 px-2 py-0.5 rounded font-bold">{doc.code}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium capitalize ${doc.type === 'law' ? 'bg-red-100 text-red-700' : doc.type === 'guideline' ? 'bg-teal-100 text-teal-700' : 'bg-amber-100 text-amber-700'}`}>{doc.type}</span>
                  </div>
                  <p className="text-sm font-semibold text-gray-800 mb-1">{doc.title}</p>
                  <p className="text-xs text-gray-500">{doc.description}</p>
                </div>
                {/* <button className="text-xs bg-amber-50 text-amber-700 border border-amber-200 px-3 py-1.5 rounded-lg hover:bg-amber-100 cursor-pointer whitespace-nowrap flex items-center gap-1 flex-shrink-0">
                  <i className="ri-file-copy-line" />Use in Report
                </button> */}
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <div className="bg-white rounded-xl border border-gray-100 p-8 text-center">
              <i className="ri-scales-3-line text-3xl text-gray-200 mb-2 block" />
              <p className="text-sm text-gray-400">No legal references found for this case type</p>
            </div>
          )}
        </div>
      </div>
    </AppLayout>
  );
}
